/**
 * Reine Ableitung der Fusszeilen-Knoepfe der Vorschau (Durchsprache 2026-09-14, Punkt 6 und 5;
 * Nutzerentscheidung 2026-09-14, Review CR-01).
 *
 * "Speichern" ist im Ruhezustand IMMER aktiv, unabhaengig davon, ob sich etwas geaendert hat --
 * bewusste Abweichung von Punkt 6, der urspruenglich nur bei `form.isDirty()` aktivieren wollte.
 * `isDirty()` erwies sich als unzuverlaessig (CR-01: sobald die Dirty-Map aus dem Zelleditor
 * einen Eintrag traegt, vergleicht sie nicht mehr die Werte selbst -- ein blosses Oeffnen und
 * Schliessen einer Zelle liess den Knopf danach faelschlich grau bleiben, auch nach dem Loeschen
 * einer Messung). Ein Speichern ohne Aenderung ist harmlos, derselbe PATCH-Request wie sonst
 * auch -- genau wie die Speichern-Knoepfe der Meldeformulare
 * (`ReportEditPage.tsx`, `disabled={isOperationInProgress && !saving}`) das schon so handhaben.
 * Waehrend ein Speichern oder Uebernehmen laeuft, bleibt er deaktiviert, damit kein zweiter
 * Request denselben Stand ueberholt.
 *
 * Punkt 5 (WR-05): Der Uebernehmen-Knopf ist ohne eine einzige uebernehmbare Messung
 * deaktiviert. Das Backend lehnt denselben Fall mit 409 ab (Plan 35.2-03) -- dieser Knopf
 * spiegelt das nur, er prueft nichts selbst und ersetzt keine Backend-Regel.
 */
export interface PreviewFooterStateInput {
  saving: boolean;
  accepting: boolean;
  measurementCount: number;
}

export interface PreviewFooterState {
  saveDisabled: boolean;
  acceptDisabled: boolean;
}

export function previewFooterState(input: PreviewFooterStateInput): PreviewFooterState {
  return {
    saveDisabled: input.saving || input.accepting,
    acceptDisabled: input.saving || input.measurementCount === 0,
  };
}
